<template>
    <div class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <Toast/>
        <div class="grid justify-content-center p-2 lg:p-0" style="min-width:80%">
            <div class="col-12 mt-5 xl:mt-0 text-center">
                <a href="/">
                    <img src="/images/contablus1.png" alt="Contablus logo" class="mb-5" style="width:200px;">
                </a>
            </div>
            <div class="col-12 xl:col-6 creds-container" style="border-radius:30px; padding:0.3rem; background-color: #f7ab47;">
                <div class="h-full w-full m-0 py-7 px-4" style="border-radius:27px; background-color: white;">
                    <div class="w-full md:w-10 mx-auto">
                        <!-- Form state -->
                        <div v-if="!sent">
                            <div class="text-center mb-5">
                                <div class="text-900 text-2xl font-medium mb-2">Recuperar contraseña</div>
                                <span class="text-600 font-medium">Ingresa tu correo y te enviaremos un enlace para restablecerla.</span>
                            </div>
                            <div class="field">
                                <label for="email" class="block text-900 text-xl font-medium mb-2">Correo</label>
                                <InputText id="email" v-model="email" type="text" class="w-full mb-3" placeholder="Correo" style="padding:1rem;" @keyup.enter="submit()"/>
                            </div>
                            <Button label="Enviar enlace" class="w-full p-3 text-xl" style="background: #27285f; border: 0px;" :loading="loading" @click="submit()"></Button>
                            <div class="text-center mt-4">
                                <a class="font-medium no-underline cursor-pointer" style="color: #27285f" @click="goToLogin()">Volver a iniciar sesión</a>
                            </div>
                        </div>

                        <!-- Confirmation state -->
                        <div v-else class="text-center">
                            <i class="pi pi-envelope" style="font-size: 3rem; color: #27285f;"></i>
                            <div class="text-900 text-2xl font-medium mt-4 mb-2">Revisa tu correo</div>
                            <span class="text-600 font-medium line-height-3">
                                Si <b>{{ email }}</b> corresponde a una cuenta, recibirás un correo con un enlace para restablecer tu contraseña. El enlace caduca en 1 hora.
                            </span>
                            <div class="text-center mt-5">
                                <a class="font-medium no-underline cursor-pointer" style="color: #27285f" @click="goToLogin()">Volver a iniciar sesión</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import httpRequest from '../service/httpRequest';

export default {
    data() {
        return {
            email: '',
            loading: false,
            sent: false,
        }
    },
    methods: {
        async submit() {
            if (!this.email || this.email.trim() === '') {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Por favor ingresa tu correo', life: 3000 });
                return;
            }

            this.loading = true;
            const response = await httpRequest.requestPasswordReset(this.email.trim());
            this.loading = false;

            // Respuesta uniforme (anti-enumeración): siempre mostramos confirmación
            if (response && response.status === 200) {
                this.sent = true;
            } else if (response && response.status === 429) {
                this.$toast.add({ severity: 'warn', summary: 'Demasiados intentos', detail: 'Has realizado demasiadas solicitudes. Espera un momento e inténtalo de nuevo.', life: 5000 });
            } else {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No pudimos procesar la solicitud. Intenta nuevamente.', life: 4000 });
            }
        },
        goToLogin() {
            this.$router.push({ name: 'login' });
        },
    }
}
</script>

<style scoped>
@media screen and (max-width: 760px) {
    .creds-container {
        width: 90%;
    }
}
</style>
